import { ClasesService } from './../../services/clases.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Clases } from 'src/app/interfaces/clases';
import { UserService } from './../../services/user.service';
import { ChatService } from './../../services/chat.service';
import { AuthenticationService } from '../../services/authentication.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';

@Component({
  selector: 'app-clase',
  templateUrl: './clase.component.html',
  styleUrls: ['./clase.component.css'],
})
export class ClaseComponent implements OnInit, OnDestroy {
  claseuid: string;
  clase: any;
  administradores = [];
  estudiantes = [];
  messagechatclase: any;
  currentuserid: string;
  chatusers = [];
  searchValue: string;
  chatorimessa = [];
  userchat: any;
  addestudiantes: any;
  addadmins: any;
  currentuseremail: any;

  userdata: any = { role: '' };
  nombres: any;
  apellidos: any;

  clasesCapadas = [
    '0MYFZ2lrZKZ69JjARsVB',
    '0MYFrkjV4l2THtX6CLGZ',
    '000LlElEx00000000',
    '000LlElEx00000001',
    '000LlElEx00000002',
    '000LlElEx00000003',
    '000LlElEx00000004',
    '000LlElEx00000005',
    '000LlElEx00000006',
    '000LlElEx00000007',
    '000LlElEx00000008',
    '000LlElEx00000009',
    '000LlElEx00000010',
    '000LlElEx00000011',
    '000LlElEx00000012',
    '000LlElEx00000013',
    '000LlElEx00000014',
    '000LlElEx00000015',
    '000LlElEx00000016',
    '000LlElEx00000017',
    '000LlElEx00000018',
  ];

  ocultarClase: boolean = true;
  obsNotificacion: any = null;
  constructor(
    private activatedRoute: ActivatedRoute,
    private clasesService: ClasesService,
    private userService: UserService,
    private chatService: ChatService,
    private notificacionesService: NotificacionesService,
    private authenticationService: AuthenticationService
  ) {}

  getClassName(): string {
    return this.clase?.name || this.clase?.nombre || '';
  }

  getClassImage(): string {
    return this.clase?.image || this.clase?.imagen || '';
  }

  getClassDescription(): string {
    return this.clase?.description || this.clase?.descripcion || '';
  }

  getClassAdmins(): string[] {
    return this.clase?.admins || this.clase?.administradores || [];
  }

  getClassUsers(): string[] {
    return this.clase?.users || this.clase?.usuarios || [];
  }

  getUserRole(user: any): string {
    return user?.role || user?.role || '';
  }

  getUserName(user: any): string {
    return user?.name || user?.nombres || '';
  }

  getUserLastName(user: any): string {
    return user?.last_name || user?.apellidos || '';
  }

  getAdminName(admin: any): string {
    return admin?.name || admin?.name || '';
  }

  getMessageData(message: any): any {
    return message?.payload?.doc?.data?.() || message || {};
  }

  getMessageSenderId(message: any): string {
    return this.getMessageData(message).sender_id || '';
  }

  getMessageContent(message: any): string {
    return this.getMessageData(message).content || '';
  }

  hasMessageContent(message: any): boolean {
    return this.getMessageContent(message).trim().length > 0;
  }

  getMessageDate(message: any): Date | null {
    const data = this.getMessageData(message);
    const value = data.created_at || data.date || data.fecha;

    if (!value) {
      return null;
    }

    if (typeof value === 'number') {
      return new Date(value);
    }

    if (value instanceof Date) {
      return value;
    }

    if (typeof value.toDate === 'function') {
      return value.toDate();
    }

    if (typeof value === 'object') {
      const seconds = value.seconds || value._seconds;
      if (typeof seconds === 'number') {
        return new Date(seconds * 1000);
      }
    }

    const parsedDate = new Date(value);
    return isNaN(parsedDate.getTime()) ? null : parsedDate;
  }

  getPrimaryAdmin(): any {
    return this.administradores.find((admin) => !!admin);
  }

  canEditClass(): boolean {
    return this.getClassAdmins().includes(this.userdata?.uid) || this.getUserRole(this.userdata) === 'director';
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.claseuid = params['uid'];
      if (this.clasesCapadas.includes(this.claseuid)) {
        this.ocultarClase = true;
      } else {
        this.ocultarClase = false;
      }
      this.administradores = [];

      const Userdata: any = this.userService.getUserinfodata();
      if (Userdata === undefined) {
        this.authenticationService.getStatus().subscribe(
          (status) => {
            this.currentuseremail = status.email;
            this.currentuserid = status.uid;
            this.authenticationService
              .isUserAdmin(this.currentuserid)
              .subscribe((userdata) => {
                if (userdata[0]) {
                  this.userdata = userdata[0];
                  this.nombres = this.getUserName(this.userdata);
                  this.apellidos = this.getUserLastName(this.userdata);
                  this.deleteNotifications();
                }
              });
          },
          (error) => {
            console.log(error);
          }
        );
      } else {
        this.currentuseremail = Userdata.payload.doc.data().email;
        this.currentuserid = Userdata.payload.doc.data().uid;
        this.userdata = Userdata.payload.doc.data();
        this.nombres = this.getUserName(this.userdata);
        this.apellidos = this.getUserLastName(this.userdata);
        this.deleteNotifications();
      }

      this.clasesService.getClaseByIdNow(this.claseuid).subscribe((laclase) => {
        if (laclase) {
          this.clase = laclase.data();
          const admins = this.getClassAdmins();
          if (admins.length > 0) {
            this.administradores = [];
            for (let index = 0; index < admins.length; index++) {
              let a = this.userService
                .getUserByIdNow(admins[index])
                .subscribe((uadmin) => {
                  uadmin.forEach((element) => {
                    this.addadmins = element.data();

                    this.administradores[index] = element.data();
                  });
                });
            }
          }

          this.estudiantes = [];
          this.getClassUsers().forEach((estudiantes) => {
            this.userService
              .getUserById(estudiantes)
              .subscribe((uestudiantes) => {
                if (!uestudiantes[0]) {
                  return;
                }

                this.addestudiantes = uestudiantes[0].payload.doc.data();
                if (
                  !this.estudiantes.some(
                    (el) => el.uid === this.addestudiantes.uid
                  )
                ) {
                  this.estudiantes.push(uestudiantes[0].payload.doc.data());
                }
              });
          });
          this.getmessages();
        }
      });
    });
  }

  deleteNotifications() {
    this.obsNotificacion = this.notificacionesService
      .getNotificacionesMensajesGrupo(this.claseuid, this.currentuserid)
      .subscribe((mensajes) => {
        // if (cortarObservable) {
        // cortarObservable = false;
        console.log('mensajes hilo: ', mensajes);
        mensajes.forEach((mensaje) => {
          const id = mensaje?.payload?.doc?.id || mensaje?.id;
          if (!id) {
            return;
          }

          this.notificacionesService.removeNotificacion(id).catch((error) => {
            console.warn('No se pudo borrar la notificacion de clase', {
              id,
              error: error?.error || error,
            });
          });
        });
        // }
      });
  }

  ngOnDestroy(): void {
    if (this.obsNotificacion != null) {
      this.obsNotificacion.unsubscribe();
    }
  }

  sendmessageclase() {
    if (this.currentuserid) {
      const content = (this.messagechatclase || '').trim();
      if (!content) {
        return;
      }

      const message = {
        sender_id: this.currentuserid,
        content,
        seen: false,
        created_at: new Date(),
      };
      const chatclassid = 'clase-' + this.claseuid;
      this.chatService
        .sendmessageclase(chatclassid, message)
        .then((datames) => {
          this.estudiantes.forEach((estudiante) => {
            if (estudiante.uid != this.currentuserid) {
              var notification = {
                reciever_id: estudiante.uid,
                content: 'Mensaje nuevo en ' + this.getClassName() + ': ' + message.content,
                url: '/dashboard/clase/' + this.claseuid,
                seen: false,
                date: new Date(),
                sender_id: this.currentuserid,
                message: true,
                event_id: null,
              };
              this.notificacionesService.createdNotificacion(notification).catch((error) => {
                console.warn('No se pudo crear la notificacion de clase', {
                  userId: estudiante.uid,
                  error: error?.error || error,
                });
              });
            }
          });
          this.messagechatclase = '';
          this.getmessages();
          setTimeout(() => this.scrolltobottom(), 0);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  getmessages() {
    const chatclassid = 'clase-' + this.claseuid;
    this.chatService.getClaseMessages(chatclassid).subscribe((message) => {
      this.chatorimessa = (message || []).filter((messageData: any) =>
        this.hasMessageContent(messageData)
      );
      this.chatorimessa.forEach((messageData: any) => {
        this.userService
          .getUserById(messageData.payload.doc.data().sender_id)
          .subscribe((userchat) => {
            if (!userchat[0]) {
              return;
            }

            this.userchat = userchat[0].payload.doc.data();
            if (!this.chatusers[this.userchat.uid]) {
              this.chatusers[this.userchat.uid] =
                userchat[0].payload.doc.data();
            }
          });
      });
    });
  }

  trackByArtNo(index: number, item: any): string {
    return item.uid;
  }

  scrolltobottom() {
    const objDiv = document.getElementById('themessagesbox');
    if (objDiv) {
      objDiv.scrollTop = objDiv.scrollHeight + 1000;
    }
  }
}
